import api from './api.js'

// 消息列表
export function getIssueInvoiceList(params){
    return api.get('/resource-order/api/v1/issue/invoice/query',params);
}

export function getIssueInvoiceByUuid(uuid){
    return api.get(`/resource-order/api/v1/issue/invoice/${uuid}`);
}

export function saveIssueInvoiceByUuid(params){
    return api.post('/resource-order/api/v1/issue/invoice/save',params);
}

export function auditIssueInvoice(params){
    return api.post('/resource-order/api/v1/issue/invoice/auditIssueInvoice',params);
}



// WEBPACK FOOTER //
// ./src/utils/issueInvoice.js